import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: { main: '#152A80' },
    secondary: { main: '#6EAA67' }
  }
})

export default theme
